
module.exports = {
  UserRegistrationRouting: require('./components/UserRegistrationRouting'),
  UserRegistrationFooter: require('./components/UserRegistrationFooter'),

  CompanyFields: require('./components/CompanyFields'),
  ProfileFormInner: require('./components/ProfileFormInner'),
  OwnersList: require('./components/OwnersList'),
  AdditionalSupportingDocs: require('./components/AdditionalSupportingDocs'),
  BankDetailsPage: require('./components/BankDetailsPage'),

  schemaCompany: require('./utils/schemaCompany'),
  schemaPersonalProfile: require('./utils/schemaPersonalProfile'),
  schemaUserData: require('./utils/schemaUserData')
}
